import * as moment from 'moment';
import { Provincia } from './provincia';
import { ClaseModalidad } from './claseModalidad';
import { ModalidadPrestacion } from './modalidadPrestacion';
import { Pasajeros } from './pasajeros';
import { Choferes } from './choferes';
import { Estado } from './estado';
import { MotivoAuxilio } from './motivoAuxilio';
import { Pais } from './pais';
import { PaisesTransito } from './paisesTransito';
import { PasoFronterizo } from './pasoFronterizo';
import { Localidad } from './localidad';

export class Viaje {
	id: number;
	fechaInicio: any;
	fechaFin: any;
	origen: string;
	provinciaOrigen: any;
	provinciaDestino: Provincia;

	//campos nuevos
	localidadOrigen: any;
	localidadDestino: any;
	paisDestino: Pais;
	paisesTransitoIda: any[];
	paisesTransitoVuelta: any[];
	excursiones: any[];
	pasosFronterizosIda: any[];
	pasosFronterizosVuelta: any[];
	cantidadCrucesIda: number;
	cantidadCrucesVuelta: number;
	paisOrigen: string;

	lugarSalida: string;
	fechaLlegadaDestino: any;
	horaLlegadaDestino: string;
	fechaSalidaDestino: any;
	horaSalidaDestino: string;
	agenciaViajesNroInscrip: string;
	fechaPasoIngreso: Date;
	fechaPasoEgreso: Date;

	destino: string;
	dominio: string;
	contenidoProgramacionTuristica?: string;
	pasajeros: Pasajeros[];
	choferes: Choferes[];
	cnrtNro: number;
	claseModalidad: ClaseModalidad;
	observaciones: string;
	fechaVencimientoRevisionTecnica: any;
	fechaVencimientoSeguro: any;
	fechaCancelacion: any;
	fechaVencimientoHabilitacion: any;
	modalidadPrestacion: ModalidadPrestacion;
	cinturonesSeguridad: boolean;
	cantidadCinturones: number;
	cantAsientos: number;
	matafuegos: boolean;
	cantidadMatafuegos: number;
	cubiertas: boolean;
	parabrisas: boolean;
	contratanteCuit: string;
	contratanteDenominacion: string;
	contratanteDomicilio: string;
	tacografoMarca: string;
	nroTacografo: string;
	viajeOriginal: number;
	viajeOriginalDominio: string;
	viajeReemplazo: number;
	viajeReemplazoDominio: string;
	estado: Estado;
	controlDominio: boolean;
	salidaEmergencia: boolean;
	martillos: boolean;
	cantidadMartillos: number;
	limitadorVelocidad: boolean;
	escotillasExpulsablesDestruibles: boolean;
	senialLuminosaSonora: boolean;
	interno: number;
	controlSeguro: boolean;
	hash: string;
	motivoAuxilio: MotivoAuxilio;
	idEmpresaAuxilio: number;
	auxilio: boolean;
	tieneTasa: boolean;
	tieneMultas: boolean;
	createdAt: any;
	prorrogaRTO: boolean;

	constructor(data = null) {
		this.pasajeros = [];
		this.choferes = [];

		if (data) {
			this.id = data.id;
			this.fechaInicio = data.fechaInicio
				? new Date(
						moment(data.fechaInicio)
							.utc(true)
							.format('YYYY-MM-DD[T]HH:mm:ss')
				  )
				: null;
			this.fechaFin = data.fechaFin
				? new Date(
						moment(data.fechaFin)
							.utc(true)
							.format('YYYY-MM-DD[T]HH:mm:ss')
				  )
				: null;
			this.origen = data.origen;
			this.excursiones = data.excursiones.map(
				excursion =>
					(excursion = {
						id: excursion.id,
						localidad: excursion.localidad,
						select: `${excursion.localidad.descripcion}-${excursion.localidad.provincia.descripcion}-${excursion.localidad.provincia.pais.descripcion}`,
					})
			);
			this.provinciaOrigen = data.provinciaOrigen;
			this.localidadOrigen = data.localidadOrigen;
			this.localidadDestino = data.localidadDestino;
			this.paisDestino = new Pais(data.paisDestino);
			this.paisOrigen = data.paisOrigen;
			this.paisesTransitoIda = data.paisesTransitoIda;
			this.paisesTransitoVuelta = data.paisesTransitoVuelta;
			this.fechaPasoEgreso = data.fechaPasoEgreso;
			this.fechaPasoIngreso = data.fechaPasoIngreso;
			this.lugarSalida = data.lugarSalida;
			this.fechaLlegadaDestino = data.fechaLlegadaDestino
				? new Date(
						moment(data.fechaLlegadaDestino)
							.utc(true)
							.format('YYYY-MM-DD[T]HH:mm:ss')
				  )
				: null;
			this.horaLlegadaDestino = data.horaLlegadaDestino;
			this.fechaSalidaDestino = data.fechaSalidaDestino
				? new Date(
						moment(data.fechaSalidaDestino)
							.utc(true)
							.format('YYYY-MM-DD[T]HH:mm:ss')
				  )
				: null;
			this.horaSalidaDestino = data.horaSalidaDestino;
			this.agenciaViajesNroInscrip = data.agenciaViajesNroInscrip;
			this.destino = data.destino;
			this.provinciaDestino = new Provincia(data.provinciaDestino);
			this.dominio = data.dominio;
			this.contenidoProgramacionTuristica = data.contenidoProgramacionTuristica;
			this.claseModalidad = data.claseModalidad;
			this.pasajeros = data.pasajeros ? data.pasajeros : [];
			this.choferes = data.choferes;
			this.cnrtNro = data.cnrtNro;
			this.observaciones = data.observaciones;
			this.fechaVencimientoRevisionTecnica = data.fechaVencimientoRevisionTecnica
				? new Date(
						moment(data.fechaVencimientoRevisionTecnica)
							.utc(true)
							.format('YYYY-MM-DD[T]HH:mm:ss')
				  )
				: null;
			this.fechaVencimientoSeguro = data.fechaVencimientoSeguro
				? new Date(
						moment(data.fechaVencimientoSeguro)
							.utc(true)
							.format('YYYY-MM-DD[T]HH:mm:ss')
				  )
				: null;
			this.fechaCancelacion = data.fechaCancelacion
				? new Date(
						moment(data.fechaCancelacion)
							.utc(true)
							.format('YYYY-MM-DD[T]HH:mm:ss')
				  )
				: null;
			this.fechaVencimientoHabilitacion = data.fechaVencimientoHabilitacion
				? new Date(
						moment(data.fechaVencimientoHabilitacion)
							.utc(true)
							.format('YYYY-MM-DD[T]HH:mm:ss')
				  )
				: null;
			this.modalidadPrestacion = data.modalidadPrestacion;
			this.cinturonesSeguridad = data.cinturonesSeguridad;
			this.cantidadCinturones = data.cantidadCinturones;
			this.matafuegos = data.matafuegos;
			this.cantidadMatafuegos = data.cantidadMatafuegos;
			this.cubiertas = data.cubiertas;
			this.parabrisas = data.parabrisas;
			this.tacografoMarca = data.tacografoMarca;
			this.nroTacografo = data.nroTacografo;
			this.contratanteCuit = data.contratanteCuit;
			this.contratanteDenominacion = data.contratanteDenominacion;
			this.contratanteDomicilio = data.contratanteDomicilio;
			this.viajeOriginal = data.viajeOriginal;
			this.viajeOriginalDominio = data.viajeOriginalDominio;
			this.viajeReemplazo = data.viajeReemplazo;
			this.viajeReemplazoDominio = data.viajeReemplazoDominio;
			this.estado = new Estado(data.estado);
			this.controlDominio = data.dominio ? true : false;
			this.salidaEmergencia = data.salidaEmergencia;
			this.martillos = data.martillos;
			this.cantidadMartillos = data.cantidadMartillos;
			this.limitadorVelocidad = data.limitadorVelocidad;
			this.escotillasExpulsablesDestruibles = data.escotillasExpulsablesDestruibles;
			this.senialLuminosaSonora = data.senialLuminosaSonora;
			this.cantAsientos = data.cantAsientos;
			this.interno = data.interno;
			this.controlSeguro = data.controlSeguro;
			this.hash = data.hash;
			this.motivoAuxilio = data.motivoAuxilio ? new MotivoAuxilio(data.motivoAuxilio) : null;
			this.idEmpresaAuxilio = data.idEmpresaAuxilio;
			this.auxilio = data.auxilio;
			this.pasosFronterizosIda = data.pasosFronterizosIda.map(
				paso =>
					(paso = {
						pasoFronterizo: paso.pasoFronterizo,
						fecha: new Date(
							moment(paso.fecha)
								.utc(true)
								.format('YYYY-MM-DD[T]HH:mm:ss')
						),
						hora: new Date(
							moment(paso.fecha)
								.utc(true)
								.format('YYYY-MM-DD[T]HH:mm:ss')
						),
						fechaYHora: new Date(
							moment(paso.fecha)
								.utc(true)
								.format('YYYY-MM-DD[T]HH:mm:ss')
						),
					})
			);
			this.pasosFronterizosVuelta = data.pasosFronterizosVuelta.map(
				paso =>
					(paso = {
						pasoFronterizo: paso.pasoFronterizo,
						fecha: new Date(
							moment(paso.fecha)
								.utc(true)
								.format('YYYY-MM-DD[T]HH:mm:ss')
						),
						hora: new Date(
							moment(paso.fecha)
								.utc(true)
								.format('YYYY-MM-DD[T]HH:mm:ss')
						),
						fechaYHora: new Date(
							moment(paso.fecha)
								.utc(true)
								.format('YYYY-MM-DD[T]HH:mm:ss')
						),
					})
			);
			this.paisOrigen = data.paisOrigen;
			this.tieneTasa = data.tieneTasa;
			this.tieneMultas = data.tieneMultas;
			this.paisDestino = new Pais(data.paisDestino);
			this.cantidadCrucesIda = data.cantidadCrucesIda;
			this.cantidadCrucesVuelta = data.cantidadCrucesVuelta;
			this.prorrogaRTO = data.prorrogaRTO;
		}
	}
}
